import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSearchStore } from '../stores/search.store'

/**
 * Old /search, /search?tab=…&q=… and /search/advanced bookmarks. The page is
 * gone (search lives in the header panel): land on the user's home (replace)
 * and, when a legacy `?q=` is present, open the header panel prefilled with it
 * — read once, never kept in the URL.
 */
export function LegacySearchRedirect() {
  const q = new URLSearchParams(useLocation().search).get('q')?.trim()
  useEffect(() => {
    if (q) useSearchStore.getState().patch({ open: true, text: q, commaAs: null, request: null, showBulk: false, tab: 'all' })
  }, [q])
  return <Navigate to="/" replace />
}
